import { FormControl, MenuItem } from "@mui/material";
import { UseFormRegister } from "react-hook-form";
import { FormState } from "react-hook-form/dist/types/form";
import { CreateCasesFormInput } from "~/pages/tickets/components/CreateTicketDialog/CreateTicketDialog";
import { CreateTicketNotesField } from "~/pages/tickets/components/CreateTicketDialog/CreateTicketNotesField";
import { CreateTicketTitleField } from "~/pages/tickets/components/CreateTicketDialog/CreateTicketTitleField";
import { CreateTicketZendeskSelectField } from "./CreateTicketZendeskSelectField";
import { ZendeskTicketContextFieldsPayload } from "~/operations";

type ZendeskFields = {
  priority: ZendeskTicketContextFieldsPayload["priority"];
  type: ZendeskTicketContextFieldsPayload["type"];
};

type CreateCaseModalProps = {
  hasCreateCasePermissions: boolean;
  register: UseFormRegister<CreateCasesFormInput>;
  formState: FormState<CreateCasesFormInput>;
  fields: ZendeskFields;
  loading: boolean;
};

export const CreateTicketZendeskDialog = ({
  register,
  formState,
  hasCreateCasePermissions,
  fields,
  loading,
}: CreateCaseModalProps) => {
  const { priority, type } = fields;
  const defaultPriority = priority?.some((p) => p.value === "normal")
    ? "normal"
    : "";
  const defaultType = type?.some((t) => t.value === "incident")
    ? "incident"
    : "";

  return (
    <>
      <FormControl fullWidth sx={{ mb: 3 }}>
        <CreateTicketTitleField
          textFieldProps={register("zendesk.title", { required: true })}
          errorMessage={formState.errors?.email?.title?.message}
          disabled={!hasCreateCasePermissions}
        />
      </FormControl>

      <FormControl fullWidth sx={{ mb: 3 }}>
        <CreateTicketZendeskSelectField
          title="Priority"
          loading={loading}
          errorMessage={formState.errors?.zendesk?.priority?.message}
          disabled={!hasCreateCasePermissions}
          defaultValue={defaultPriority}
          registration={register("zendesk.priority", { required: true })}
        >
          {fields.priority?.map((p) => (
            <MenuItem value={p.value} key={p.value}>
              {p.displayName}
            </MenuItem>
          ))}
        </CreateTicketZendeskSelectField>
      </FormControl>
      <FormControl fullWidth sx={{ mb: 3 }}>
        <CreateTicketZendeskSelectField
          title="Type"
          loading={loading}
          errorMessage={formState.errors?.zendesk?.zendeskType?.message}
          disabled={!hasCreateCasePermissions}
          defaultValue={defaultType}
          registration={register("zendesk.zendeskType")}
        >
          {fields.type?.map((t) => (
            <MenuItem value={t.value} key={t.value}>
              {t.displayName}
            </MenuItem>
          ))}
        </CreateTicketZendeskSelectField>
      </FormControl>
      <FormControl fullWidth>
        <CreateTicketNotesField
          errorMessage={formState.errors.zendesk?.notes?.message}
          textFieldProps={register("zendesk.notes")}
          disabled={!hasCreateCasePermissions}
        />
      </FormControl>
    </>
  );
};
